import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { extend } from '@syncfusion/ej2-base';
import { KanbanComponent, CardSettingsModel, ColumnsModel, DialogSettingsModel, SwimlaneSettingsModel, CardRenderedEventArgs } from '@syncfusion/ej2-angular-kanban';
import { cardData, kanbanData, routeData } from './data'; // in main folder.
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DemoService } from 'src/app/demo.service';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { DataUtil } from 'node_modules/@syncfusion/ej2-data';
import { ContextMenuSettingsModel } from '@syncfusion/ej2-angular-diagrams';
import { addClass } from 'node_modules/@syncfusion/ej2-base';
import { BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs/internal/Observable';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-app-routes-diagram-kan-pan-data-component',
  templateUrl: './app-routes-diagram-kan-pan-data-component.component.html',
  styleUrls: ['./app-routes-diagram-kan-pan-data-component.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppRoutesDiagramKanPanDataComponentComponent implements OnInit, OnChanges {


// setup as observable?
@Input() item_id?; // impliments on changes. // Base set to Job_ID
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size?; // side | abstract | full
@Input() current_field_name?;

@Input() promotion_id: number;
@Input() current_route: any;

search_model: AppRoute;
public contextMenuSettings: ContextMenuSettingsModel;

  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  new_data: any;
  // array_of_routes:any[];
  app_routes_metrix_search_full: Object;
  app_routes_metrix_search_full_results: any;

// Kan Ban Defauults
  // @ViewChild('kanbanObj') kanbanObj: KanbanComponent;
  // public kanbanData: Object[] = extend([], kanbanData, null, true) as Object[];
  // public cardSettings: CardSettingsModel = {
  //     contentField: 'Summary',
  //     headerField: 'Id',
  //     tagsField: 'Tags',
  //     grabberField: 'Color',
  //     footerCssField: 'ClassName'
  // };
  // end kan ban defaults



  // Kan Ban Full Overview
  @ViewChild('kanbanObj') kanbanObj: KanbanComponent;
  public kanbanData: Object[] = extend([], cardData, null, true) as Object[];
  
  // Changed The Model so I caoul add my own cars to header colums.
  // public columns: any[] = []
  public columns: ColumnsModel[] = [
    // { headerText: 'Concept', keyField: 'Concept', allowToggle: true, isExpanded: false },
    // { headerText: 'Tip', keyField: 'Tip', allowToggle: true,  isExpanded: true}, 
    // { headerText: 'To Do', keyField: 'Open', allowToggle: true,  isExpanded: true},
    //   // { headerText: 'Quoted', keyField: 'Quoted', allowToggle: true, isExpanded: false},
    //   { headerText: 'In Dev', keyField: 'InDev', allowToggle: true,  isExpanded: true },
    //   // { headerText: 'In Progress', keyField: 'InProgress', allowToggle: true,  isExpanded: true },
    //   // { headerText: 'Being Updated', keyField: 'InUpgrades', allowToggle: true, isExpanded: false },
    //   // { headerText: 'LocalBuild', keyField: 'LocalBuild', allowToggle: true ,  isExpanded: true},
    //   { headerText: 'Testing', keyField: 'Testing', allowToggle: true,  isExpanded: true },
    //   // { headerText: 'In Review', keyField: 'Review', allowToggle: true, isExpanded: false },
    //   // { headerText: 'LiveBuild', keyField: 'LiveBuild', allowToggle: true, isExpanded: false },
    //   { headerText: 'Done', keyField: 'Close', allowToggle: true , isExpanded: false}
  ];


  public cardSettings: CardSettingsModel = {
      headerField: 'Title',
      template: '#cardTemplate',
      selectionType: 'Multiple'
  };


  public dialogSettings: DialogSettingsModel = {
      fields: [
          { text: 'ID', key: 'Title', type: 'TextBox' },
          { key: 'Status', type: 'DropDown' },
          { key: 'Assignee', type: 'DropDown' },
          { key: 'RankId', type: 'TextBox' },
          { key: 'Summary', type: 'TextArea' }
      ]
  };
  // public swimlaneSettings: SwimlaneSettingsModel = { keyField: 'Assignee' }; // default
  // public swimlaneSettings: SwimlaneSettingsModel = { keyField: 'brand_type_name' };
  public swimlaneSettings: SwimlaneSettingsModel = { keyField: 'user_level_name' ,  allowDragAndDrop: false  };

 // End Kan Ban Full Overview

public myData: Object[] = [
  {
    "Id": "20",
    "Title": "PPS Orders Daily Actions",
    "Status": "Open",
    "Summary": "Generate Todays Pick and Pack List, Label Bulk Printing and Get Pick Pack Send ...ing.... :)",
    "Type": "Story",
    "Priority": "Low",
    "Tags": "Analyze,Customer",
    "Estimate": 3,
    "Assignee": "Nancy Davloio",
    "RankId": 0,
    "Color": "#690580",
    "ClassName": "fa fa-shopping-"
  },
  {
    "Id": "19",
    "Title": "System App Route Update UI - Administrator",
    "Status": "Closed",
    "Summary": "_COPY **** of **** Administrator Routes UI",
    "Type": "Story",
    "Priority": "Low",
    "Tags": "Analyze,Customer",
    "Estimate": 1,
    "Assignee": "Nancy Davloio",
    "RankId": 1,
    "Color": null,
    "ClassName": null
  },
  {
    "Id": "18",
    "Title": "System App Routes",
    "Status": "Open",
    "Summary": "Administrator Routes UI",
    "Type": "Story",
    "Priority": "Low",
    "Tags": "Analyze,Customer",
    "Estimate": 2,
    "Assignee": "Nancy Davloio",
    "RankId": 2,
    "Color": null,
    "ClassName": null
  },
  {
    "Id": "17",
    "Title": "test_COPY",
    "Status": "Quoted",
    "Summary": "Just testing for the diagrams",
    "Type": "Story",
    "Priority": "Low",
    "Tags": "Analyze,Customer",
    "Estimate": 3,
    "Assignee": "Nancy Davloio",
    "RankId": 3,
    "Color": "#db0606",
    "ClassName": null
  },
  {
    "Id": "15",
    "Title": "System Test Route",
    "Status": "Open",
    "Summary": "General Test Route Entry for developer data entry and testing UI and Data Interactions and Logic.",
    "Type": "Story",
    "Priority": "Low",
    "Tags": "Analyze,Customer",
    "Estimate": 4,
    "Assignee": "Nancy Davloio",
    "RankId": 4,
    "Color": "#f54429",
    "ClassName": "fa fa-sitemap"
  },
  {
    "Id": "14",
    "Title": "PPS Dashbaord",
    "Status": "Open",
    "Summary": "This is a help module for the dashboard and introduction",
    "Type": "Story",
    "Priority": "Low",
    "Tags": "Analyze,Customer",
    "Estimate": 5,
    "Assignee": "Nancy Davloio",
    "RankId": 5,
    "Color": "#3e2c42",
    "ClassName": "fa fa-dashboard"
  }
]


// public array_of_routes: Object[] = extend([], routeData, null, true) as Object[]; // SETS THE OBJECT TO THE CARD DATA METHOD.
// public array_of_routes: Object[] = extend([], cardData, null, true) as Object[]; // SETS THE OBJECT TO THE CARD DATA METHOD.
// public array_of_routes: Object[]; // SETS THE OBJECT TO THE CARD DATA METHOD.
public array_of_routes: Object[] = extend([], this.item_data, null, true) as Object[]; // SETS THE OBJECT TO THE CARD DATA METHOD.


public array_of_routes_b: Object[] = extend([], routeData, null, true) as Object[]; // SETS THE OBJECT TO THE CARD DATA METHOD.
  modalRef: any;
  app_route_insert_types: ColumnsModel;
  isExpanded_Col: boolean;



  constructor(
    public gfunc: GlobalFunctionsService,
    private _demoService: DemoService,
    private router: Router,  private route: ActivatedRoute,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    public toastr: HotToastService,
  ) {
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


this.search_model = new AppRoute()
this.getAppRouteInsertTypes(); // set the colums



   }


  //  const assignee_Brand_Namess_array: string[] = ['Andrew Fuller', 'Janet Leverling', 'Steven walker', 'Robert King', 'Margaret hamilt', 'Nancy Davloio', 'Margaret Buchanan', 'Laura Bergs', 'Anton Fleet', 'Jack Kathryn', 'Martin Davolio', 'Fleet Jack'];
//Kan Ban Functions
public getString(assignee: string) {
  // return assignee.match(/\b(\w)/g).join('').toUpperCase(); // was creating errors in my data
}
cardRendered(args: CardRenderedEventArgs): void {
  // const val: string = (<{[key: string]: Object}>(args.data)).Priority as string;
  // addClass([args.element], val);

  // this.toastr.info('card rendered function');
}

// End kan Ban Functions



  /// NOT WORKING COFRECTLY ON CHANGES... STUFFS UP LOADING ALL ITEMS -- only loads one and resets tje data object!!!
  /// BUG.. so load all information from the array. -- get the sent array of items like I do with the action list itens....ss

// Show and hide items.


  ngOnChanges(changes): void  {
    // this.toastr.success('we detected onchanges kanban...')


if(this.widget_size == 'under_the_hood'){
  this.getAppRouteInsertTypes_UnderTheHood(); // set the colums

}else{
  this.getAppRouteInsertTypes(); // set the colums

}

    // this.search_model = new AppRoute()
    this.loadRoutes(this.item_data)
    


            // // this.search_model = new AppRoute()
            // if (changes.item_id || changes.item_data ) {
            //   // deal with asynchronous Observable result
            //   this.item_id = changes.item_id.currentValue;
            //   this.item_data= changes.item_data.currentValue;
            //   // this.getJob(this.job_id);
          

            //     // new if pushed item_data
            //     // this.search_model = new AppRoute();

            // if (changes.item_data) {

            //       this.new_data = changes.item_data.currentValue;
            //       console.log('New Data Loaded: ', JSON.stringify(this.new_data));
            //       // this.getAppRouteInsertTypes(); // set the colums moved to constructor
            //       this.loadRoutes(this.new_data);


            // }  }

  }


   ngOnInit(): void {
      // this.array_of_routes = this.array_of_routes;

          // this.search_model = new AppRoute();
          // // this.getFormUserLevels();
          // // this.getBrandBrandTypes();
          // // this.getBrandsComboBoxAgents(this.combo_model);
          // // this.getJobsTableData();

          // this.search_model = {}// set to empty to get all first.

          // // this.getVariableCodeBlocksSearchFull(this.search_model);
          // this.getAppRoutesSearchFull(this.search_model);
          // this.toastr.success('Loaded Routes on init')
  }



  loadRoutes(new_data){
    const countME = new_data

// console.log('Item Data: ' + JSON.stringify(new_data));

    let  count_of_trigger_items = Object.keys(countME).length; // creating errors in kabnan
    // let  count_of_trigger_items = this.new_data.length;

    let test_data = new_data;

    this.array_of_routes =[]; // just declair so we can push
    // now loop and push to join model
    for(let i=0;i < count_of_trigger_items; i++) {
      
      // let res2 = this.new_data[i];
      // let res2 = this.new_data[i];
      let res2 = test_data[i];

      // var logs_type_triggers = JSON.parse(data[i].system_automation_array);
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        // if(logs_type_triggers.some(person => person == this.system_automation_id )){ } // end if exists in the current row array
  
        // if(res2.app_route_parent_id != 0 && res2.app_route_parent_id != null)
     
     
      //   this.array_of_routes.push({
      // //  log_type_name: res2.log_type_name,
      // //  log_type_id: res2.log_type_id,
      // //  log_type_colour: res2.log_type_colour,
      // //  log_type_icon: res2.log_type_icon,
      // //  log_type_description: res2.log_type_description,
      // //  is_active: res2.is_active,
      //     //TREE
      //     // app_route_id: res2.app_route_id,
      //     // app_route_parent_id: res2.app_route_parent_id,
      //     // app_route_name: res2.app_route_name,
          
      //     // KanPan

      //      Id: res2.app_route_id,
      //     Title: res2.app_route_name,
      //     Status: 'Open',
      //     Summary: res2.app_route_description,
      //     Type: 'Story',
      //     Priority: 'Low',
      //     Tags: 'Analyze,Customer',
      //     // Tags: res2.app_route_keywords,
      //     Estimate: 3.5,
      //     Assignee: 'Nancy Davloio',
      //     RankId: 1,
      //     Color: res2.app_route_colour,
      //     ClassName: res2.app_route_icon,



      //           });




      // if(res2.app_route_parent_id == 0 || res2.app_route_parent_id == null){ }
        // this.array_of_routes.push({
        //   Id: res2.app_route_id,
        //   Title: res2.app_route_name,
        //   Status: 'Open',
        //   Summary: res2.app_route_description,
        //   Type: 'Story',
        //   Priority: 'Low',
        //   Tags: 'Analyze,Customer',
        //   // Tags: res2.app_route_keywords,
        //   Estimate: i,
        //   Assignee: res2.app_route_created_by,
        //   RankId: i,
        //   Color: res2.app_route_colour,
        //   ClassName: res2.app_route_icon,
        //             });

        // let title = res2.guided_tour_content + ' ' + res2.app_route_name
     
        this.array_of_routes.push({
          Id: res2.app_route_id,
          Title: res2.app_route_name,
          // Status: 'Open',
          Status: res2.app_route_insert_type_name,
          Summary: res2.app_route_description,
          Type: 'Story',
          Priority: 'Low',
          Tags: 'Analyze,Customer',
          // Tags: res2.app_route_keywords,
          Estimate: i,
          Assignee: res2.app_route_created_by,
          RankId: i,
          Color: res2.app_route_colour,
          ClassName: res2.app_route_icon,
          ...res2
                    });
  
              
    
    } // end app routes loop.
    
    // this.array_of_routes = this.array_of_routes;
    this.array_of_routes = extend([], this.array_of_routes, null, true) as Object[]; // SETS THE OBJECT TO THE CARD DATA METHOD.

  }

    
  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
        // Now load the routes into the kanban
        this.loadRoutes(this.new_data);      

                        // Simples now works for passed data as well as Lookups form item_id and search criteria etc....
                        if(this.item_data){
                          this.new_data = DataUtil.parse.parseJson(this.item_data);
                                  // Now load the routes into the kanban
                          this.loadRoutes(this.item_data);      
                        }

        

  
        // const species: object[] = [
        //   { 'Name': 'Species', 'fillColor': '#3DD94A' },
        //   { 'Name': 'Plants', 'Category': 'Species' },
        //   { 'Name': 'Fungi', 'Category': 'Species' },
        //   { 'Name': 'Lichens', 'Category': 'Species' },
        //   { 'Name': 'Animals', 'Category': 'Species' },
        //   { 'Name': 'Mosses', 'Category': 'Plants' },
        //   { 'Name': 'Ferns', 'Category': 'Plants' },
        //   { 'Name': 'Gymnosperms', 'Category': 'Plants' },
        //   { 'Name': 'Dicotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Monocotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Invertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Vertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Insects', 'Category': 'Invertebrates' },
        //   { 'Name': 'Molluscs', 'Category': 'Invertebrates' },
        //   { 'Name': 'Crustaceans', 'Category': 'Invertebrates' },
        //   { 'Name': 'Others', 'Category': 'Invertebrates' },
        //   { 'Name': 'Fish', 'Category': 'Vertebrates' },
        //   { 'Name': 'Amphibians', 'Category': 'Vertebrates' },
        //   { 'Name': 'Reptiles', 'Category': 'Vertebrates' },
        //   { 'Name': 'Birds', 'Category': 'Vertebrates' },
        //   { 'Name': 'Mammals', 'Category': 'Vertebrates' }
        // ];

        // this.species = species

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );     
      }


setSwimLane(field){
  this.setSwimLane = field;
  this.swimlaneSettings = { keyField: 'user_level_name' };
}


// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};



    
getAppRouteInsertTypes() {
  this._demoService.getAppRouteInsertTypes().subscribe(
      data => { this.app_route_insert_types = data; 
        let res = data[0]
      
        this.columns = [];
        // let  count_of_trigger_items = Object.keys(this.app_route_insert_types).length; // creating errors in kabnan
        // let  count_of_trigger_items = Object.keys(res).length; //  kabnan
        let  count_of_trigger_items = Object.keys(res).length + 1; //  kabnan -- was missing the last in the liast
        console.log('length: ', count_of_trigger_items)
        
        
       

        for(let i=0;i < count_of_trigger_items; i++) {
          let loop_res = this.app_route_insert_types[i];
         

          this.isExpanded_Col = false;
          let isExpanded_Col = false;

          if(loop_res.isExpanded == "true"){
          isExpanded_Col = true;
          }

// if(loop_res.app_route_id != 5 || loop_res.app_route_id != 6 || loop_res.app_route_id != 7 || loop_res.app_route_id != 12 || loop_res.app_route_id != 13 || loop_res.app_route_id != 14 ){  } // end if  

          // app_route_logo: loop_res.app_route_logo, app_route_colour: loop_res.app_route_colour
          this.columns.push({
            headerText: loop_res.app_route_insert_type_name , keyField: loop_res.app_route_insert_type_name , allowToggle: loop_res.allowToggle , isExpanded: isExpanded_Col, 
            allowDrag: false, allowDrop: false
            
          });           

          
                
        } // end app routes loop.
        // this.columns = this.columns;
        // let isExpanded: Boolean = false;

        // // Setup the Types Based in insert types (Colums) // DYNAMIC FROM DATABASE
        //   this.columns =  [
        //     { headerText: 'Concept', keyField: 'Concept', allowToggle: true,  isExpanded: false}, 
        //     { headerText: 'Tip', keyField: 'Tip', allowToggle: true,  isExpanded: true}, 
        //     { headerText: 'To Do', keyField: 'Open', allowToggle: true,  isExpanded: true},
        //       { headerText: 'Quoted', keyField: 'Quoted', allowToggle: true, isExpanded: false},
        //       { headerText: 'In Dev', keyField: 'InDevelopment', allowToggle: true,  isExpanded: true },
        //       { headerText: 'In Progress', keyField: 'InProgress', allowToggle: true,  isExpanded: false },
        //       { headerText: 'Being Updated', keyField: 'InUpgrades', allowToggle: true, isExpanded: false },
        //       { headerText: 'LocalBuild', keyField: 'LocalBuild', allowToggle: true ,  isExpanded: true},
        //       { headerText: 'Testing', keyField: 'Testing', allowToggle: true,  isExpanded: false },
        //       { headerText: 'In Review', keyField: 'Review', allowToggle: true, isExpanded: false },
        //       { headerText: 'LiveBuild', keyField: 'LiveBuild', allowToggle: true, isExpanded: false },
        //       { headerText: 'Done', keyField: 'Close', allowToggle: true , isExpanded: false}
        //   ];

      
      
      
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getAppRouteInsertTypes_UnderTheHood() {
    this._demoService.getAppRouteInsertTypes().subscribe(
        data => { this.app_route_insert_types = data; 
          let res = data[0]
        
          this.columns = [];
          // let  count_of_trigger_items = Object.keys(this.app_route_insert_types).length; // creating errors in kabnan
          // let  count_of_trigger_items = Object.keys(res).length; //  kabnan
          let  count_of_trigger_items = Object.keys(res).length + 1; //  kabnan -- was missing the last in the liast
          console.log('length: ', count_of_trigger_items)
          
          
         
  
          for(let i=0;i < count_of_trigger_items; i++) {
            let loop_res = this.app_route_insert_types[i];
           
  
            this.isExpanded_Col = false;
            let isExpanded_Col = false;
  
            if(loop_res.isExpanded == "true"){
            isExpanded_Col = true;
            }
  
  if(loop_res.app_route_insert_type_id != 5 && loop_res.app_route_insert_type_id != 6 && loop_res.app_route_insert_type_id != 7 && loop_res.app_route_insert_type_id != 12 && loop_res.app_route_insert_type_id != 13 && loop_res.app_route_insert_type_id != 14 && loop_res.app_route_insert_type_id != 18 ){
  
            // app_route_logo: loop_res.app_route_logo, app_route_colour: loop_res.app_route_colour
            this.columns.push({
              headerText: loop_res.app_route_insert_type_name , keyField: loop_res.app_route_insert_type_name , allowToggle: loop_res.allowToggle , isExpanded: isExpanded_Col, 
              allowDrag: false, allowDrop: false
              
            });           
  
          } // end if      
                  
          } // end app routes loop.
          // this.columns = this.columns;
          // let isExpanded: Boolean = false;
  
          // // Setup the Types Based in insert types (Colums) // DYNAMIC FROM DATABASE
          //   this.columns =  [
          //     { headerText: 'Concept', keyField: 'Concept', allowToggle: true,  isExpanded: false}, 
          //     { headerText: 'Tip', keyField: 'Tip', allowToggle: true,  isExpanded: true}, 
          //     { headerText: 'To Do', keyField: 'Open', allowToggle: true,  isExpanded: true},
          //       { headerText: 'Quoted', keyField: 'Quoted', allowToggle: true, isExpanded: false},
          //       { headerText: 'In Dev', keyField: 'InDevelopment', allowToggle: true,  isExpanded: true },
          //       { headerText: 'In Progress', keyField: 'InProgress', allowToggle: true,  isExpanded: false },
          //       { headerText: 'Being Updated', keyField: 'InUpgrades', allowToggle: true, isExpanded: false },
          //       { headerText: 'LocalBuild', keyField: 'LocalBuild', allowToggle: true ,  isExpanded: true},
          //       { headerText: 'Testing', keyField: 'Testing', allowToggle: true,  isExpanded: false },
          //       { headerText: 'In Review', keyField: 'Review', allowToggle: true, isExpanded: false },
          //       { headerText: 'LiveBuild', keyField: 'LiveBuild', allowToggle: true, isExpanded: false },
          //       { headerText: 'Done', keyField: 'Close', allowToggle: true , isExpanded: false}
          //   ];
  
        
        
        
        },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }
// Get New App Notes and Collect Like I do with the Routes Bove... Do  matrix and search call so that I can have this sorted from to step go...

/*

// Build A simple UI to CRUD for APP Notes - Copy File Notes Grid....... (Module and then build from there.... ) -- now or after I KanBan actions and scheules happeing.


// Simple Model of Kan Ban Task -- need to convert my data over for App Notes.... 
  {
    'Id': 'Task 1',
    'Title': 'Task - 29001',
    'Status': 'Open',
    'Summary': 'Analyze the new requirements gathered from the customer.',
    'Type': 'Story',
    'Priority': 'Low',
    'Tags': 'Analyze,Customer',
    'Estimate': 3.5,
    'Assignee': 'Nancy Davloio',
    'RankId': 1,
    'Color': '#02897B',
    'ClassName': 'e-story, e-low, e-nancy-davloio'
  },
*/


showQuoteRoutesOnly(){
  this.search_model = {
    app_route_type_id: 10,
  }// set to empty to get all first.
  this.getAppRoutesSearchFull(this.search_model);
}


showTipsRoutesOnly(){
  this.search_model = {
    app_route_insert_type_id: 5,
  }// set to empty to get all first.
  this.getAppRoutesSearchFull(this.search_model);
}



  clearSearchResults(search_model){
    this.new_data = [];
    this.search_model = {}// set to empty to get all first.
    // this.getVariableCodeBlocksSearchFull(this.search_model);
    this.getAppRoutesSearchFull(this.search_model);
    // this.grid.refresh()
    
    }
    



}
